import { addMinutes, format } from 'date-fns'
import * as R from 'ramda'

import { START_TIME_FORMAT } from '../constants/flights'

import { Flight } from '../schemas/Flight'

const playersLens = R.lensProp('players')

const filterByPlayer = (playerId, tournamentFlights = []) =>
  R.filter(
    tournamentFlight =>
      R.any(flightPlayerId => flightPlayerId === playerId, R.view(playersLens, tournamentFlight)),
    tournamentFlights,
  )

const removePlayerFromFlight = (playerId, tournamentFlights) =>
  R.map(
    tournamentFlight =>
      R.over(
        playersLens,
        R.filter(flightPlayerId => flightPlayerId !== playerId),
        tournamentFlight,
      ),
    tournamentFlights,
  )

export const withRemovedPlayer = (playerId, tournamentFlights) =>
  removePlayerFromFlight(playerId, filterByPlayer(playerId, tournamentFlights))

export const withBatchSetStartTime = (flights: Flight[]) => (
  startTime: Date,
  interval: number,
  applyFrom: number,
) => {
  const sortedFlights = R.sortBy(R.prop('number'), flights)

  return sortedFlights.slice(applyFrom - 1).reduce(
    (acc, flight) => ({
      flights: [...acc.flights, { ...flight, startTime: format(acc.startTime, START_TIME_FORMAT) }],
      startTime: addMinutes(acc.startTime, interval),
    }),
    { flights: [], startTime } as FIXME,
  ).flights
}

const flightNumberLens = R.lensProp('number')

export const followingFlightsWithDecrementedNumber: (
  current: Flight,
) => (allFlights: Flight[]) => Flight[] = (current: Flight) =>
  R.compose(
    R.map(R.over(flightNumberLens, R.add(-1))),
    R.dropWhile((other: FIXME) => other.number <= current.number),
    R.sortBy(R.prop('number')),
    R.filter((other: FIXME) => other.number && other.round === current.round),
  ) as FIXME

const padWithZeros = (length: number) => (str: string) =>
  R.slice(0, length - str.length, R.repeat('0', length)) + str

export const printFlightNumber = (flight: Flight) => `${padWithZeros(2)(flight.number.toString())}`

export const countPlayers: (flights: Flight[]) => number = R.compose(
  R.sum,
  R.map(
    R.compose(
      R.length as FIXME,
      R.prop('players'),
    ),
  ),
)

export const sortedFlightsInRound: (round: number) => (flights: Flight[]) => Flight[] = (
  round: number,
) =>
  R.compose(
    R.sort(R.ascend(R.prop('number'))),
    R.filter((flight: FIXME) => flight.round === round),
  )



// WEBPACK FOOTER //
// ./src/helpers/flights.ts